import { render, staticRenderFns } from "./BasePDFQuestionRenderer.vue?vue&type=template&id=ae2ebb06&scoped=true&"
import script from "./BasePDFQuestionRenderer.vue?vue&type=script&lang=js&"
export * from "./BasePDFQuestionRenderer.vue?vue&type=script&lang=js&"
import style0 from "./BasePDFQuestionRenderer.vue?vue&type=style&index=0&id=ae2ebb06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2ebb06",
  null
  
)

export default component.exports